import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import { SelectCustom, HttpError, InputCustom, Loading } from "../../components"
import * as ApiHelper from "../../ApiHelper"
import * as constants from "../../constants"
import Util from "../../Util"
import PendenciasModal from "./PendenciasModal"
import LoadModalWithLabel from "./LoadModalWithLabel"
import { ToastContainer, ToastMessage } from "react-toastr"
class SolicitacaoForm extends Component {
  constructor() {
    super()
    this.onChangeFiscal = this.onChangeFiscal.bind(this)
    this.getFiscalWithId = this.getFiscalWithId.bind(this)
    this.onChangeContrato = this.onChangeContrato.bind(this)
    this.onChangeItemPendencia = this.onChangeItemPendencia.bind(this)
    this.onChangeItemReferencia = this.onChangeItemReferencia.bind(this)
    this.removeItem = this.removeItem.bind(this)
    this.addItem = this.addItem.bind(this)
    this.sendForm = this.sendForm.bind(this)
    this.handleErrors = this.handleErrors.bind(this)
    this.getInitialFields = this.getInitialFields.bind(this)
    this.togglePendenciaModal = this.togglePendenciaModal.bind(this)
    this.reloadPendencia = this.reloadPendencia.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false,
      showForm: false,
      fiscais: [],
      fiscal: "",
      contratos: [{ value: null, label: "" }],
      contrato: "",
      currentPendencias: [],
      pendencias: [{ pendencia: "", referencia: "" }],
      pendenciasError: [{ pendencia: "", referencia: "" }],
      editingPendenciaID: "",
      showPendenciaModal: false
    }
    this.showSucessMessage = this.showSucessMessage.bind(this)
    this.toastFactory = React.createFactory(ToastMessage.animation)
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  showSucessMessage() {
    var message = ""
    var title = "Sucesso"
    if (this.props.isEditing) {
      message =
        "Solicitação de esclarecimento e providencias atualizada com sucesso"
    } else {
      message =
        "Solicitação de esclarecimento e providencias cadastrada com sucesso"
    }
    this.container.success(title, message, {
      timeOut: 2000,
      extendedTimeOut: 3000
    })
  }
  showErrorMessage() {
    this.container.error(
      "Ocorreram erros",
      "Verifique os dados e tente novamente",
      {
        timeOut: 2000,
        extendedTimeOut: 3000
      }
    )
  }
  componentWillMount() {
    if (this.props.isEditing) {
      this.getInitialFields()
    } else {
      this.getFiscais()
    }
  }
  addItem(event) {
    event.preventDefault()
    var oldPendencias = this.state.pendencias
    var oldPendenciasError = this.state.pendenciasError
    oldPendencias.push({ pendencia: "", referencia: "" })
    oldPendenciasError.push({ pendencia: "", referencia: "" })
    this.setState({
      pendencias: oldPendencias,
      pendenciasError: oldPendenciasError
    })
  }
  removeItem(event) {
    event.preventDefault()
    var oldPendencias = this.state.pendencias
    var oldPendenciasError = this.state.pendenciasError
    oldPendencias.pop()
    oldPendenciasError.pop()
    this.setState({
      pendencias: oldPendencias,
      pendenciasError: oldPendenciasError
    })
  }
  getFiscais() {
    if (!constants.userIsFiscal()) {
      ApiHelper.getFiscais((fiscais, error) => {
        if (fiscais) {
          this.setState(
            {
              fiscais: Util.mapFiscais(fiscais),
              showForm: true
            },
            () => {
              window.scrollTo(0, 0)
            }
          )
        } else {
          this.setState({
            httpError: error
          })
        }
      })
    } else {
      ApiHelper.getMe(() => {
        var contratos = Util.mapContratos(constants.getUserContratos())
        this.setState({
          fiscal: constants.getUserID(),
          showForm: true,
          contratos: contratos
        })
      })
    }
  }
  getInitialFields() {
    ApiHelper.getSolicitacoesEdit(this.props.match.params.id, (data, error) => {
      if (data) {
        this.fillFields(data.solicitacao)
        this.setState(
          {
            fiscais: data.fiscais,
            pendencias: [],
            showForm: true
          },
          () => {
            var fiscalID = data.solicitacao.contrato.fiscal_id
            var contratos = this.getFiscalWithId(fiscalID).contratos
            this.setState(
              {
                contratos: Util.mapContratos(contratos),
                fiscal: fiscalID,
                currentPendencias: data.solicitacao.pendencias
              },
              () => {
                window.scrollTo(0, 0)
              }
            )
          }
        )
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  fillFields(fields) {
    var currentFields = {
      contrato: fields.num_contrato,
      num_contratoLabel: fields.contrato.num_contrato
    }
    this.setState(currentFields)
  }
  sendForm(event) {
    event.preventDefault()
    var pendencias = []
    this.state.pendencias.forEach(pendencia => {
      pendencias.push({
        ref_contratual: pendencia.referencia,
        pendencia: pendencia.pendencia
      })
    })
    var params = {
      num_contrato: this.state.contrato,
      pendencias: pendencias
    }
    this.toggleLoadModal()
    if (this.props.isEditing) {
      ApiHelper.updateSolicitacoesEsclarecimentos(
        this.props.match.params.id,
        params,
        error => {
          this.toggleLoadModal()
          if (error) {
            this.showErrorMessage()
            this.handleErrors(error)
          } else {
            this.showSucessMessage()
            Util.sleep(3000).then(() => {
              this.props.callBackSolicitacao()
            })
          }
        }
      )
    } else {
      ApiHelper.sendNewSolicitacoesEsclarecimentos(params, error => {
        this.toggleLoadModal()
        if (error) {
          this.showErrorMessage()
          this.handleErrors(error)
        } else {
          this.showSucessMessage()
          Util.sleep(3000).then(() => {
            this.props.callBackSolicitacao()
          })
        }
      })
    }
  }
  handleErrors(errors) {
    var errorsJSON = JSON.parse(errors)
    var errorsValue = errorsJSON.erros
    var errorsState = {}
    var pendenciasError = this.state.pendenciasError
    for (var key in errorsValue) {
      if (key.includes("pendencias.")) {
        var index = key.split("pendencias.").join("")
        if (index.includes(".pendencia")) {
          index = index.split(".pendencia").join("")
          pendenciasError[index].pendencia = errorsValue[key][0]
        }
        if (index.includes(".ref_contratual")) {
          index = index.split(".ref_contratual").join("")
          pendenciasError[index].ref_contratual = errorsValue[key][0]
        }
      } else {
        errorsState[key + "Error"] = errorsValue[key][0]
      }
    }
    errorsState.pendenciasError = pendenciasError
    this.setState(errorsState)
  }
  onChangeItemReferencia(event, id) {
    var newValue = event.target.value
    var oldPendencias = this.state.pendencias
    var oldPendenciasError = this.state.pendenciasError
    oldPendencias[id].referencia = newValue
    oldPendenciasError[id].ref_contratual = ""
    this.setState({
      pendencias: oldPendencias,
      pendenciasError: oldPendenciasError
    })
  }
  onChangeItemPendencia(event, id) {
    var newValue = event.target.value
    var oldPendencias = this.state.pendencias
    var oldPendenciasError = this.state.pendenciasError
    oldPendencias[id].pendencia = newValue
    oldPendenciasError[id].pendencia = ""
    this.setState({
      pendencias: oldPendencias,
      pendenciasError: oldPendenciasError
    })
  }
  getFiscalWithId(id) {
    var fiscalFound = ""
    this.state.fiscais.forEach(fiscal => {
      if (fiscal.value === parseInt(id, 10)) fiscalFound = fiscal
    })
    return fiscalFound
  }
  onChangeContrato(event) {
    var newValue = event.target.value
    this.setState({
      num_contratoError: "",
      contrato: newValue
    })
  }
  onChangeFiscal(event) {
    var newValue = event.target.value
    this.setState(
      {
        fiscal_idError: "",
        contrato: "",
        fiscal: newValue
      },
      () => {
        var contratos = this.getFiscalWithId(this.state.fiscal).contratos
        this.setState(
          {
            contratos: contratos ? Util.mapContratos(contratos) : []
          },
          () => {
            if (this.state.contratos.length === 1) {
              this.setState({
                fiscal_idError: "Este fiscal não possui contratos cadastrados"
              })
            }
          }
        )
      }
    )
  }
  removePendencia(event, key, id) {
    event.preventDefault()
    ApiHelper.deletePendencia(id, error => {
      if (error) {
        this.addAlert("", error.message)
      } else {
        var oldItens = this.state.currentPendencias
        oldItens.splice(key, 1)
        this.setState({
          currentPendencias: oldItens
        })
      }
    })
  }
  togglePendenciaModal(event, key, id) {
    event.preventDefault()
    this.setState({
      editingPendenciaID: id,
      showPendenciaModal: !this.state.showPendenciaModal
    })
  }
  reloadPendencia(value) {
    var id = value.id
    var oldCurrentPendencias = this.state.currentPendencias
    oldCurrentPendencias.forEach((pendencia, index) => {
      if (pendencia.id === id) {
        oldCurrentPendencias[index] = value
      }
    })
    this.setState({
      currentPendencias: oldCurrentPendencias,
      showPendenciaModal: !this.state.showPendenciaModal
    })
  }
  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  render() {
    if (this.state.httpError) {
      return (
        <div className="container-fluid">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </div>
      )
    }
    return (
      <div className="container-fluid">
        <LoadModalWithLabel
          label="Aguarde..."
          onClose={this.toggleLoadModal}
          show={this.state.showLoad}
        />
        <PendenciasModal
          pendenciaId={this.state.editingPendenciaID}
          callBack={this.reloadPendencia}
          show={this.state.showPendenciaModal}
          onClose={this.togglePendenciaModal}
        />
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <div>
          {this.state.showForm === false && <Loading />}
          {this.state.showForm === true && (
            <div className="card card-plain">
              <div className="card-header" data-background-color="as-blue">
                <h4 className="title">
                  {this.props.isEditing
                    ? "Editar formulário de esclarecimento e providências"
                    : "Criar formulário de esclarecimento e providências"}
                </h4>
                <p className="category">
                  {this.props.isEditing
                    ? "Formulário de esclarecimento e providências do contrato: " +
                      this.state.num_contratoLabel
                    : "Criar novo formulário de esclarecimento e providências"}
                </p>
              </div>
              <div className="card-content">
                <form>
                  <div className="row">
                    {!constants.userIsFiscal() && (
                      <SelectCustom
                        error={this.state.fiscal_idError}
                        sizeClass="col-md-4"
                        options={this.state.fiscais}
                        label="Selecione um fiscal"
                        name="fiscal"
                        value={this.state.fiscal}
                        onChange={this.onChangeFiscal}
                      />
                    )}
                  </div>
                  {this.state.contratos.length > 1 && (
                    <div>
                      <div className="row">
                        <SelectCustom
                          error={this.state.num_contratoError}
                          sizeClass="col-md-4"
                          options={this.state.contratos}
                          label={"Selecione um contrato"}
                          name={"contrato"}
                          value={this.state.contrato}
                          onChange={this.onChangeContrato}
                        />
                      </div>
                      {this.state.currentPendencias.map((pendencia, key) => {
                        return (
                          <div key={key}>
                            <div className="card">
                              <div className="card-content">
                                <div className="row">
                                  <InputCustom
                                    sizeClass="col-md-5"
                                    label="Pendência"
                                    onChange={event =>
                                      this.onChangeItemPendencia(event, key)
                                    }
                                    value={pendencia.pendencia}
                                    disabled={true}
                                  />
                                  <InputCustom
                                    sizeClass="col-md-5"
                                    label="Referência contratual"
                                    onChange={event =>
                                      this.onChangeItemReferencia(event, key)
                                    }
                                    value={pendencia.ref_contratual}
                                    disabled={true}
                                  />
                                  <button
                                    title="Remover"
                                    onClick={event =>
                                      this.removePendencia(
                                        event,
                                        key,
                                        pendencia.id
                                      )
                                    }
                                    className="btn btn-danger pull-left"
                                    data-background-color="red"
                                  >
                                    <i className="icon-header material-icons">
                                      delete
                                    </i>
                                  </button>
                                  <button
                                    title="Editar"
                                    onClick={event =>
                                      this.togglePendenciaModal(
                                        event,
                                        key,
                                        pendencia.id
                                      )
                                    }
                                    className="btn btn-danger pull-left"
                                    data-background-color="blue"
                                  >
                                    <i className="icon-header material-icons">
                                      create
                                    </i>
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      {this.state.pendencias.map((pendencia, key) => {
                        return (
                          <div key={key}>
                            <div className="card">
                              <div className="card-content">
                                <div className="row">
                                  <InputCustom
                                    error={
                                      this.state.pendenciasError[key].pendencia
                                    }
                                    sizeClass="col-md-5"
                                    label="Pendência"
                                    onChange={event =>
                                      this.onChangeItemPendencia(event, key)
                                    }
                                    value={pendencia.pendencia}
                                  />
                                  <InputCustom
                                    error={
                                      this.state.pendenciasError[key]
                                        .ref_contratual
                                    }
                                    sizeClass="col-md-5"
                                    label="Referência contratual"
                                    onChange={event =>
                                      this.onChangeItemReferencia(event, key)
                                    }
                                    value={pendencia.referencia}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })}
                      <button
                        onClick={this.removeItem}
                        className="btn btn-danger pull-left"
                        data-background-color="red"
                      >
                        <i className="icon-header material-icons">remove</i>
                      </button>
                      <button
                        onClick={this.addItem}
                        className="btn btn-primary pull-left"
                        data-background-color="green"
                      >
                        <i className="icon-header material-icons">add</i>
                      </button>
                    </div>
                  )}
                  <button
                    onClick={this.sendForm}
                    type="submit"
                    className="btn btn-primary pull-right"
                    data-background-color="as-blue"
                  >
                    {this.props.isEditing ? "Salvar" : "Criar"}
                  </button>
                </form>
              </div>
            </div>
          )}
        </div>
      </div>
    )
  }
}
export default withRouter(SolicitacaoForm)



// WEBPACK FOOTER //
// ./src/views/modais/SolicitacaoForm.js